import { motion } from "framer-motion";
import { Clapperboard } from "lucide-react";

const FOUNDER_IMG = "/gallery/creator-founder.jpg";

export default function Founder() {
  return (
    <section id="founder" data-testid="founder-section" className="relative py-20 lg:py-32 px-4 sm:px-8 lg:px-16 bg-surface/40">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          <div className="clip-frame border border-white/15 overflow-hidden">
            <img src={FOUNDER_IMG} alt="Jean Luc — creator and founder of The Zo Pound Experience" data-testid="founder-image" className="w-full h-[520px] object-cover object-top" />
          </div>
          <div className="absolute -bottom-4 -right-4 bg-blood px-5 py-3 flex items-center gap-2">
            <Clapperboard size={16} />
            <span className="font-mono text-[10px] uppercase tracking-[0.25em]">Simplicity Films, LLC</span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-blood mb-4">Creator &amp; Founder</p>
          <h2 className="font-display font-black uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight">
            Jean Luc
          </h2>
          <p className="mt-2 font-mono text-xs uppercase tracking-widest text-gray-500">
            Written · Produced · Directed
          </p>
          <blockquote className="mt-8 border-l-2 border-blood pl-6 text-lg sm:text-xl text-gray-300 leading-relaxed italic">
            "My name is Jean Luc and I am the founder and creator of THE ZO POUND EXPERIENCE SHOW.
            I created this podcast to highlight the great things Haitians have contributed to the world —
            and they deserve respect."
          </blockquote>
          <p className="mt-6 text-base text-gray-400 leading-relaxed">
            A Simplicity Films, LLC production, THE ZO POUND EXPERIENCE is a gold mine packed with
            powerful information about what's going on around the world — including the US — from a
            Haitian/American point of view.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
